<iboxtools *ngIf="verDetalle" [Title]="" 
            isHistory='true' 
            [enableBack]="true" 
            [DateInit]="afiliacion?.desde" 
            [DateEnd]="afiliacion?.hasta"
            [IsEditing]="isEditing" 
            (BackChange)="OnBackChange()" 
            [PeriodList]="afiliacionesHistoryList" 
            (DeleteChange)="OnDeleteChange($event)" 
            (NewChange)="OnNewChange($event)"
            (EditChange)="OnEditChange($event)" 
            (PeriodChange)="OnPeriodChange($event)" 
            (CancelChange)="OnCancelChange($event)" 
            (SaveChange)="OnSaveChange($event)" 
            (CutChange)="OnCutChange()"
            [Permiso]="permisoEdicion"
            [CurrentPeriod]="afiliacion?.id">
</iboxtools>

<app-afiliaciones-list *ngIf="!verDetalle && !buscando" [personalId]="personalId" 
                                                             [afiliaciones]="afiliaciones" 
                                                             [permisoEdicion]="permisoEdicion"
                                                             (VisualizarDetalle)="OnVisualizarDetalle($event)">
</app-afiliaciones-list>

<app-afiliaciones-detalle #ChildAfiliacionDetalle [afiliacion]="afiliacion" *ngIf="verDetalle" 
                            [enabledForm]="habilitarFormDetalle" 
                            [MensajeError]="MensajeError" 
                            [desdeAnterior]="desdeAnterior" 
                            [ingreso]="ingreso"
                            [anteriorRetroactividad]="anteriorRetroactividad" 
                            [grupoLiq]="gruposLiquidaciones"
                            [afiliacionesInvalida]="afiliacionesInvalida">
</app-afiliaciones-detalle>

